import { analytics } from '@sendgrid/bloodhound';
import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@sendgrid/ui-components/checkbox';
import withAccountInputs from '../containers/withAccountInputs';
import { AccountInputsEvents } from '../analytics/accountInputsEvents';

const onTosClick = () => {
  analytics.track(AccountInputsEvents.termsOfServiceClicked());
};

const onPrivacyPolicyClick = () => {
  analytics.track(AccountInputsEvents.privacyPolicyClicked());
};

const EmailToS = () => (
  <Fragment>
    I accept the
    {' '}
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://sendgrid.com/policies/tos/"
      data-role="tos-link"
      onClick={onTosClick}
    >
      Terms of Service
    </a>
    {' '}
and have read the
    {' '}
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://sendgrid.com/policies/privacy/services-privacy-policy/"
      data-role="privacy-policy-link"
      onClick={onPrivacyPolicyClick}
    >
      Services Privacy Policy
    </a>
  </Fragment>
);

const AdsToS = () => (
  <Fragment>
    I accept the
    {' '}
    <a
      target="_blank"
      rel="noopener noreferrer"
      href=" https://sendgrid.com/labs/tos/"
      data-role="tos-link"
    >
    SendGrid Labs Terms of Service
    </a>
  </Fragment>
);

export class ToSInfo extends PureComponent {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange() {
    this.props.toggleTos(!this.props.formInputs.tos);
  }

  render() {
    return (
      <div className="tos-info" data-role="tos-container">
        <Checkbox
          onChange={this.handleChange}
          id="checkbox-ToS"
          data-role="checkbox-ToS"
        >
          {!this.props.isAds
            && <EmailToS />
          }
          {this.props.isAds
            && <AdsToS />
          }
        </Checkbox>
      </div>
    );
  }
}

ToSInfo.propTypes = {
  toggleTos: PropTypes.func.isRequired,
  isAds: PropTypes.bool,
  formInputs: PropTypes.shape({
    tos: PropTypes.number,
  }).isRequired,
};

ToSInfo.defaultProps = {
  isAds: false,
};

const ConnectedToSInfo = withAccountInputs(ToSInfo);
export default ConnectedToSInfo;
